import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["column", "card"]
  static values = { url: String }

  dragStart(event) {
    this.draggedCard = event.target.closest("[data-kanban-target='card']")
    this.draggedCard.classList.add("opacity-50", "rotate-2")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.draggedCard.dataset.clientId)
  }

  dragEnd(event) {
    this.draggedCard.classList.remove("opacity-50", "rotate-2")
    // Remove all drop indicators
    this.columnTargets.forEach(col => col.classList.remove("bg-orange-50", "ring-2", "ring-orange-300"))
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const column = event.target.closest("[data-kanban-target='column']")
    if (!column) return

    // Highlight target column
    this.columnTargets.forEach(col => col.classList.remove("bg-orange-50", "ring-2", "ring-orange-300"))
    column.classList.add("bg-orange-50", "ring-2", "ring-orange-300")

    // Position card within column
    const card = this.draggedCard
    const afterElement = this.getDragAfterElement(column, event.clientY)

    if (afterElement) {
      column.insertBefore(card, afterElement)
    } else {
      // Remove "Sin clientes" placeholder if present
      const placeholder = column.querySelector(".text-center")
      if (placeholder) placeholder.remove()
      column.appendChild(card)
    }
  }

  async drop(event) {
    event.preventDefault()

    const column = event.target.closest("[data-kanban-target='column']")
    if (!column) return

    column.classList.remove("bg-orange-50", "ring-2", "ring-orange-300")

    const clientId = this.draggedCard.dataset.clientId
    const stageId = column.dataset.stageId
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({ client_id: clientId, funnel_stage_id: stageId })
      })

      if (response.ok) {
        this.showToast("Cliente movido")
        this.updateCounts()
      } else {
        this.showToast("Error al mover cliente", true)
      }
    } catch (e) {
      this.showToast("Error al mover cliente", true)
    }
  }

  getDragAfterElement(column, y) {
    const cards = [...column.querySelectorAll("[data-kanban-target='card']:not(.opacity-50)")]
    return cards.reduce((closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child }
      } else {
        return closest
      }
    }, { offset: Number.NEGATIVE_INFINITY }).element
  }

  updateCounts() {
    this.columnTargets.forEach(column => {
      const count = column.querySelectorAll("[data-kanban-target='card']").length
      const badge = column.closest(".flex-col").querySelector(".rounded-full.bg-white")
      if (badge) badge.textContent = count
    })
  }

  showToast(message, isError = false) {
    const existing = document.getElementById("kanban-toast")
    if (existing) existing.remove()

    const toast = document.createElement("div")
    toast.id = "kanban-toast"
    toast.className = `fixed bottom-6 right-6 z-50 px-4 py-3 rounded-lg shadow-lg text-sm font-medium transition-all duration-300 ${
      isError ? "bg-red-600 text-white" : "bg-gray-800 text-white"
    }`
    toast.textContent = message
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.style.opacity = "0"
      setTimeout(() => toast.remove(), 300)
    }, 2000)
  }
}
